import { apiBaseUrl } from 'app/src/msw/membership/api/apiBaseUrl'
import { http, HttpResponse } from 'msw'

const fakePrivacyDocumentUpdateUri = apiBaseUrl + '/fakeuploadurl'

export const uploadFamilyMemberPrivacyDocument = http.put<object, object, object>(fakePrivacyDocumentUpdateUri, async () => {
  return HttpResponse.json({}, { status: 201 })
})
